import DashboardKPIs from './DashboardKPIs';
import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import ViewActionsBar from '../../components/Dashboard/ViewActionsBar';
import { DefaultKPIsWidgets, KPIsWidgetEnum, TrafikLedarAdminWidgets } from './utils';
import KPIsFilterBar from './KPIsFilterBar';
import useMe from 'contexts/authentication/useMe';
import Roles, { includesRoles } from 'constants/Roles';
import { Navigate } from 'react-router-dom';
import Routes from 'constants/Routes';

const KPIsPage = () => {
  const me = useMe();
  const roles = me?.roles ?? [];

  const isSuperAdmin = includesRoles([Roles.SuperAdmin], roles);
  const isAdmin = includesRoles([Roles.Admin], roles);
  const isTeamLeadAndTrafikLedarAdmin =
    includesRoles([Roles.TeamLead], roles) &&
    includesRoles([Roles.TrafikLedarAdmin], roles);

  if (!isSuperAdmin && !isAdmin && !isTeamLeadAndTrafikLedarAdmin) {
    return <Navigate to={Routes.notFound} />;
  }

  const widgets = isSuperAdmin
    ? DefaultKPIsWidgets
    : isAdmin || isTeamLeadAndTrafikLedarAdmin
      ? TrafikLedarAdminWidgets
      : TrafikLedarAdminWidgets;

  return (
    <DashboardControlsProvider<KPIsWidgetEnum>
      storageKey={isSuperAdmin ? 'KPIs' : 'KPIs_TL'}
      defaultWidgets={widgets}
    >
      <KPIsFilterBar />
      <ViewActionsBar />
      <DashboardKPIs />
    </DashboardControlsProvider>
  );
};

export default KPIsPage;
